'use client';

import { useEffect, useState } from 'react';
import { filterActiveAlgoliaPromotions } from '@libs/common-next';
import type { EligiblePromotion } from '@libs/common-types';
import type { AutoshipHeaderProps } from './types';

const getAutoshipPromo = (promotions?: Array<EligiblePromotion>) => {
    if (!promotions?.length) return null;

    const activePromotions = filterActiveAlgoliaPromotions({
        promotions,
        isAutoshipHeader: true,
    });
    const autoshipPromos = activePromotions?.filter(
        (promo: EligiblePromotion) => promo?.type === 'autoship'
    );
    if (!autoshipPromos?.length) {
        return null;
    }
    // if there is only 1 autoship promo, return it
    if (autoshipPromos.length === 1) {
        return autoshipPromos[0];
    }
    // there are multiple autoship promos: return first non-default promo
    const nonDefaultPromos = autoshipPromos.filter(promo => !promo.default);

    // in case of scenerio where there are multiple default but no non-default, return first default promo
    return nonDefaultPromos?.length ? nonDefaultPromos[0] : autoshipPromos[0];
};

export default function AutoshipHeader({
    eligiblePromotions,
    userHasSubscriptions,
}: Readonly<AutoshipHeaderProps>) {
    const [autoshipMessageCT, setAutoshipMessageCT] = useState('');

    // CT Promotions
    useEffect(() => {
        const autoshipPromo = getAutoshipPromo(eligiblePromotions);
        if (autoshipPromo?.discountDisplay) {
            const message = userHasSubscriptions
                ? ' & Save 5%'
                : ` & Save ${autoshipPromo.discountDisplay}`;
            setAutoshipMessageCT(message);
        }
    }, [eligiblePromotions, userHasSubscriptions]);

    return (
        <span className="radio-field-title sparky-u-theme-typography-body-lg-bold">
            {`Autoship${autoshipMessageCT}`}
        </span>
    );
}
